var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"devoluciones-nav p-t-15 align-start"},[_c('div',{staticClass:"j-start align-start"},[_c('input-sale-num'),_c('search-client')],1),_c('div',{staticClass:"j-end"},[_c('btn-marcar-todo-devuelto'),_c('btn-cancel')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }